// You can write more code here

/* START OF COMPILED CODE */

import BaseScene from "../core/scenes/BaseScene";
import BtnAudio from "../core/prefabs/BtnAudio";
import UIPositionContainer from "../core/components/UIPositionContainer";
import TaxiCard from "../prefabs/TaxiCard";
import BtnPlay from "../core/prefabs/BtnPlay";
import FitTextToBounds from "../core/components/FitTextToBounds";
import LocaliseText from "../core/components/LocaliseText";
/* START-USER-IMPORTS */
import { app } from '../core/App';
import UIButton from '../core/components/UIButton';
import { TransitionPoint } from '../app-routing';
import { CharacterName } from "../Character";
import { GameDataHandler } from "../GameDataHandler";
/* END-USER-IMPORTS */

export default class Title extends BaseScene {

  constructor() {
    super("Title");

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {

    // bg
    const bg = this.add.image(960, 384, "title", "bg-title.jpg");

    // btnAudio
    const btnAudio = new BtnAudio(this, 1845, 73.5);
    this.add.existing(btnAudio);

    // water_jet_png
    const water_jet_png = this.add.image(1109, 422, "title", "water-jet.png");

    // cab_png
    const cab_png = this.add.image(1040, 545, "title", "cab.png");

    // star_1_png
    const star_1_png = this.add.image(1079, 486, "title", "star-1.png");

    // star_2_png
    const star_2_png = this.add.image(1099, 498, "title", "star-2.png");

    // star_3_png
    const star_3_png = this.add.image(1128, 495, "title", "star-3.png");

    // star_4_png
    const star_4_png = this.add.image(1133, 511, "title", "star-4.png");

    // star_5_png
    const star_5_png = this.add.image(1149, 523, "title", "star-5.png");

    // pigeon_1_png
    const pigeon_1_png = this.add.image(533, 189, "title", "pigeon-1.png");

    // pigeon_2_png
    const pigeon_2_png = this.add.image(691, 310, "title", "pigeon-2.png");

    // pigeon_3_png
    const pigeon_3_png = this.add.image(982, 374, "title", "pigeon-3.png");

    // pigeon_4_png
    const pigeon_4_png = this.add.image(1030, 434, "title", "pigeon-4.png");

    // pigeon_5_png
    const pigeon_5_png = this.add.image(1314, 102, "title", "pigeon-5.png");

    // toots_taxi_shadow_png
    const toots_taxi_shadow_png = this.add.image(517, 618, "title", "toots-taxi-shadow.png");

    // toots_taxi_png
    const toots_taxi_png = this.add.image(574, 497, "title", "toots-taxi.png");

    // spike_taxi_shadow_png
    const spike_taxi_shadow_png = this.add.image(824, 652, "title", "spike-taxi-shadow.png");

    // spike_taxi_png
    const spike_taxi_png = this.add.image(832, 519, "title", "spike-taxi.png");

    // tom
    const tom = this.add.image(1230, 449, "title", "tom.png");

    // tom_taxi_card_png
    const tom_taxi_card_png = new TaxiCard(this, 1225, 549);
    this.add.existing(tom_taxi_card_png);
    tom_taxi_card_png.scaleX = 0.37;
    tom_taxi_card_png.scaleY = 0.37;
    tom_taxi_card_png.angle = 35;

    // jerry
    const jerry = this.add.image(1411, 600, "title", "jerry.png");

    // jerry_taxi_card_png1
    const jerry_taxi_card_png1 = this.add.image(1424, 391, "title", "jerry-taxi-card.png");
    jerry_taxi_card_png1.visible = false;

    // jerry_taxi_card_png
    const jerry_taxi_card_png = new TaxiCard(this, 1426, 392);
    this.add.existing(jerry_taxi_card_png);
    jerry_taxi_card_png.scaleX = 0.46;
    jerry_taxi_card_png.scaleY = 0.46;
    jerry_taxi_card_png.angle = -43;

    // feather_group_1_png
    const feather_group_1_png = this.add.image(1266, 193, "title", "feather-group-1.png");

    // feather_group_2_png
    const feather_group_2_png = this.add.image(978, 372, "title", "feather-group-2.png");

    // feather_group_3_png
    const feather_group_3_png = this.add.image(595, 192, "title", "feather-group-3.png");

    // title
    const title = this.add.image(960, 140, "title", "logo.png");

    // subtitleOld
    const subtitleOld = this.add.image(960, 311, "title", "title-en.png");
    subtitleOld.visible = false;

    // btnPlay
    const btnPlay = new BtnPlay(this, 960, 638);
    this.add.existing(btnPlay);

    // subtitle
    const subtitle = this.add.text(957, 317, "", {});
    subtitle.setOrigin(0.5, 0.5);
    subtitle.text = "Top Speed";
    subtitle.setStyle({ "align": "center", "color": "#1b1b1bff", "fixedWidth":600,"fontFamily": "FREDFREDBURGERHEADLINE-BLACK", "fontSize": "70px", "strokeThickness":5});

    // btnAudio (components)
    const btnAudioUIPositionContainer = new UIPositionContainer(btnAudio);
    btnAudioUIPositionContainer.offsetX = 24;
    btnAudioUIPositionContainer.offsetY = 24;
    btnAudioUIPositionContainer.PinRight = true;
    btnAudioUIPositionContainer.PinTop = true;

    // subtitle (components)
    const subtitleFitTextToBounds = new FitTextToBounds(subtitle);
    subtitleFitTextToBounds.maxWidth = 600;
    subtitleFitTextToBounds.minFontSize = 5;
    const subtitleLocaliseText = new LocaliseText(subtitle);
    subtitleLocaliseText.copyId = "taxiCabs";

    this.bg = bg;
    this.btnAudio = btnAudio;
    this.water_jet_png = water_jet_png;
    this.cab_png = cab_png;
    this.star_1_png = star_1_png;
    this.star_2_png = star_2_png;
    this.star_3_png = star_3_png;
    this.star_4_png = star_4_png;
    this.star_5_png = star_5_png;
    this.pigeon_1_png = pigeon_1_png;
    this.pigeon_2_png = pigeon_2_png;
    this.pigeon_3_png = pigeon_3_png;
    this.pigeon_4_png = pigeon_4_png;
    this.pigeon_5_png = pigeon_5_png;
    this.toots_taxi_shadow_png = toots_taxi_shadow_png;
    this.toots_taxi_png = toots_taxi_png;
    this.spike_taxi_shadow_png = spike_taxi_shadow_png;
    this.spike_taxi_png = spike_taxi_png;
    this.tom = tom;
    this.tom_taxi_card_png = tom_taxi_card_png;
    this.jerry = jerry;
    this.jerry_taxi_card_png1 = jerry_taxi_card_png1;
    this.jerry_taxi_card_png = jerry_taxi_card_png;
    this.feather_group_1_png = feather_group_1_png;
    this.feather_group_2_png = feather_group_2_png;
    this.feather_group_3_png = feather_group_3_png;
    this.title = title;
    this.subtitleOld = subtitleOld;
    this.btnPlay = btnPlay;
    this.subtitle = subtitle;

    this.events.emit("scene-awake");
  }

  private bg!: Phaser.GameObjects.Image;
  private btnAudio!: BtnAudio;
  private water_jet_png!: Phaser.GameObjects.Image;
  private cab_png!: Phaser.GameObjects.Image;
  private star_1_png!: Phaser.GameObjects.Image;
  private star_2_png!: Phaser.GameObjects.Image;
  private star_3_png!: Phaser.GameObjects.Image;
  private star_4_png!: Phaser.GameObjects.Image;
  private star_5_png!: Phaser.GameObjects.Image;
  private pigeon_1_png!: Phaser.GameObjects.Image;
  private pigeon_2_png!: Phaser.GameObjects.Image;
  private pigeon_3_png!: Phaser.GameObjects.Image;
  private pigeon_4_png!: Phaser.GameObjects.Image;
  private pigeon_5_png!: Phaser.GameObjects.Image;
  private toots_taxi_shadow_png!: Phaser.GameObjects.Image;
  private toots_taxi_png!: Phaser.GameObjects.Image;
  private spike_taxi_shadow_png!: Phaser.GameObjects.Image;
  private spike_taxi_png!: Phaser.GameObjects.Image;
  private tom!: Phaser.GameObjects.Image;
  private tom_taxi_card_png!: TaxiCard;
  private jerry!: Phaser.GameObjects.Image;
  private jerry_taxi_card_png1!: Phaser.GameObjects.Image;
  private jerry_taxi_card_png!: TaxiCard;
  private feather_group_1_png!: Phaser.GameObjects.Image;
  private feather_group_2_png!: Phaser.GameObjects.Image;
  private feather_group_3_png!: Phaser.GameObjects.Image;
  private title!: Phaser.GameObjects.Image;
  private subtitleOld!: Phaser.GameObjects.Image;
  private btnPlay!: BtnPlay;
  private subtitle!: Phaser.GameObjects.Text;

  /* START-USER-CODE */

  protected tomX:number = 0;
  protected tomY:number = 0;
  protected jerryX:number = 0;
  protected jerryY:number = 0;
  protected spikeX:number = 0;
  protected spikeY:number = 0;
  protected tootsX:number = 0;
  protected tootsY:number = 0;
  protected spikeShadowX:number = 0;
  protected spikeShadowY:number = 0;
  protected tootsShadowX:number = 0;
  protected tootsShadowY:number = 0;
  protected p1X:number = 0;
  protected p1Y:number = 0;
  protected p2X:number = 0;
  protected p2Y:number = 0;
  protected p3X:number = 0;
  protected p3Y:number = 0;
  protected p4X:number = 0;
  protected p4Y:number = 0;
  protected p5X:number = 0;
  protected p5Y:number = 0;
  protected waterX:number = 0;
  protected waterY:number = 0;
  protected cabX:number = 0;
  protected cabY: number = 0;
  protected card1InitScale: number = 0;
  protected card1InitAngle: number = 0;
  protected card1X:number = 0;
  protected card1Y: number = 0;
  protected card2InitScale: number = 0;
  protected card2InitAngle: number = 0;
  protected card2X:number = 0;
  protected card2Y:number = 0;


  public preload() {
    super.preload();

    // this.load.pack('asset-pack-title', assetPack as any);

    this.load.on(Phaser.Loader.Events.COMPLETE, this.postload, this);
  }

  public postload() {
    super.postload();

    console.log(this.cache);
    console.log(this.textures);
    // app.unload(this, assetPack);
  }

  public create() {
    super.create();
    this.editorCreate();

    this.tomX = this.tom.x;
    this.tomY = this.tom.y;
    this.jerryX = this.jerry.x;
    this.jerryY = this.jerry.y;
    this.spikeX = this.spike_taxi_png.x;
    this.spikeY = this.spike_taxi_png.y;
    this.tootsX = this.toots_taxi_png.x;
    this.tootsY = this.toots_taxi_png.y;
    this.spikeShadowX = this.spike_taxi_shadow_png.x;
    this.spikeShadowY = this.spike_taxi_shadow_png.y;
    this.tootsShadowX = this.toots_taxi_shadow_png.x;
    this.tootsShadowY = this.toots_taxi_shadow_png.y;

    this.p1X = this.pigeon_1_png.x;
    this.p1Y = this.pigeon_1_png.y;
    this.p2X = this.pigeon_2_png.x;
    this.p2Y = this.pigeon_2_png.y;
    this.p3X = this.pigeon_3_png.x;
    this.p3Y = this.pigeon_3_png.y;
    this.p4X = this.pigeon_4_png.x;
    this.p4Y = this.pigeon_4_png.y;
    this.p5X = this.pigeon_5_png.x;
    this.p5Y = this.pigeon_5_png.y;

    this.waterX = this.water_jet_png.x;
    this.waterY = this.water_jet_png.y;

    this.cabX = this.cab_png.x;
    this.cabY = this.cab_png.y;

    this.card1X = this.tom_taxi_card_png.x;
    this.card1Y = this.tom_taxi_card_png.y;

    this.card2X = this.jerry_taxi_card_png.x;
    this.card2Y = this.jerry_taxi_card_png.y;

    this.tom_taxi_card_png.changeOwner(CharacterName.Tom);
    this.tom_taxi_card_png.x -= 100;
    this.tom_taxi_card_png.y += 80;
    this.card1InitAngle = this.tom_taxi_card_png.angle;
    this.tom_taxi_card_png.angle += 50;
    this.card1InitScale = this.tom_taxi_card_png.scale;
    this.tom_taxi_card_png.scale = 0.0;

    this.jerry_taxi_card_png.changeOwner(CharacterName.Jerry);
    this.jerry_taxi_card_png.x -= 30;
    this.jerry_taxi_card_png.y += 100;
    this.card2InitAngle = this.jerry_taxi_card_png.angle;
    this.jerry_taxi_card_png.angle += 50;
    this.card2InitScale = this.jerry_taxi_card_png.scale;
    this.jerry_taxi_card_png.scale = 0.0;

    this.pigeon_1_png.x += 250;
    this.pigeon_1_png.y += 320;
    this.pigeon_1_png.scale = 0.0;

    this.pigeon_2_png.x += 180;
    this.pigeon_2_png.y += 250;
    this.pigeon_2_png.scale = 0.0;

    this.pigeon_3_png.x -= 10;
    this.pigeon_3_png.y += 100;
    this.pigeon_3_png.scale = 0.0;

    this.pigeon_4_png.x -= 20;
    this.pigeon_4_png.y += 60;
    this.pigeon_4_png.scale = 0.0;

    this.pigeon_5_png.x -= 180;
    this.pigeon_5_png.y += 250;
    this.pigeon_5_png.scale = 0.0;

    this.water_jet_png.scale = 0;
    this.water_jet_png.y +=150;

    this.cab_png.scale = 1.05;
    this.cab_png.x +=10;
    this.cab_png.y +=10;

    this.tom.x -= 30;
    this.tom.y -=10;
    this.tom.scale = 0.8;

    this.jerry.x -= 80;
    this.jerry.y -=10;
    this.jerry.scale = 0.7;

    this.spike_taxi_png.x += 30;
    this.spike_taxi_png.y +=5;
    this.spike_taxi_png.scale = 0.2;

    this.spike_taxi_shadow_png.x += 30;
    this.spike_taxi_shadow_png.y -=110;
    this.spike_taxi_shadow_png.scale = 0.0;

    this.toots_taxi_png.x += 270;
    this.toots_taxi_png.y +=30;
    this.toots_taxi_png.scale = 0.1;

    this.toots_taxi_shadow_png.x += 270;
    this.toots_taxi_shadow_png.y -=70;
    this.toots_taxi_shadow_png.scale = 0.0;

    this.feather_group_1_png.scale = 0.0;
    this.feather_group_2_png.scale = 0.0;
    this.feather_group_3_png.scale = 0.0;

    this.star_1_png.alpha=1;
    this.star_1_png.scale=0;
    this.star_2_png.alpha=1;
    this.star_2_png.scale=0;
    this.star_3_png.alpha=1;
    this.star_3_png.scale=0;
    this.star_4_png.alpha=1;
    this.star_4_png.scale=0;
    this.star_5_png.alpha=1;
    this.star_5_png.scale=0;

    this.bg.scale = 1.05;

    const transitionPoint = app.dataHandler.IsFirstRun ? TransitionPoint.TitleEndFirstTime : TransitionPoint.TitleEnd;
    this.btnPlay.once(UIButton.events.clicked, () => {
      app.gotoNextScene(this, transitionPoint, { test: 'test' });
    });

    // let localisedImage = app.localeHandler.getLocalisedImageFromId('brandLogo', { texture: this.subtitle.texture.key, frame: this.subtitle.frame.name });
    //this.subtitle.setTexture(localisedImage.texture, localisedImage.frame);

    this.transitionInInit();
    //this.time.addEvent({ delay: 100, callback: this.transitionIn, callbackScope: this });
    this.transitionIn();
    // this.transitionOn();

    app.audioHandler.playSound(this, 'SndGameMusicLoop', 'music', {
      volume: 0.2,
      loop: true
    });
  }

  protected transitionInInit() {
    this.title.scale = 0.0;
    this.subtitle.scale = 0.0;
    this.btnPlay.y = 900;
  }

  protected transitionIn() {
    this.add.tween({
      targets: this.title,
      scaleX: 1,
      scaleY: 1,
      duration: 1000,
      delay:250,
      ease: Phaser.Math.Easing.Cubic.Out
    });

    this.add.tween({
      targets: this.subtitle,
      scaleX: 1,
      scaleY: 1,
      duration: 1250,
      delay:400,
      ease: Phaser.Math.Easing.Cubic.Out
    });

    this.add.tween({
      targets: this.btnPlay,
      y: 639,
      duration: 750,
      ease: Phaser.Math.Easing.Cubic.InOut
    });

    this.add.tween({
      targets: this.bg,
      scale: 1,
      duration: 1500,
      ease: Phaser.Math.Easing.Cubic.Out
    });

    this.add.tween({
      targets: this.tom,
      x: this.tomX,
      y: this.tomY,
      scale: 1,
      duration: 1800,
      ease: Phaser.Math.Easing.Cubic.Out,
      onComplete: this.tomIdle,
      onCompleteScope: this
    });

    this.add.tween({
      targets: this.jerry,
      x: this.jerryX,
      y: this.jerryY,
      scale: 1,
      duration: 1800,
      ease: Phaser.Math.Easing.Cubic.Out,
      onComplete: this.jerryIdle,
      onCompleteScope: this
    });

    this.add.tween({
      targets: this.tom_taxi_card_png,
      x: this.card1X,
      y: this.card1Y,
      angle: this.card1InitAngle,
      scale: this.card1InitScale,
      duration: 1600,
      delay:100,
      ease: Phaser.Math.Easing.Quadratic.Out,
      onComplete: this.tomCardIdle,
      onCompleteScope: this
    });

    this.add.tween({
      targets: this.jerry_taxi_card_png,
      x: this.card2X,
      y: this.card2Y,
      angle: this.card2InitAngle,
      scale: this.card2InitScale,
      duration: 1600,
      delay:200,
      ease: Phaser.Math.Easing.Quadratic.Out,
      onComplete: this.jerryCardIdle,
      onCompleteScope: this
    });

    this.add.tween({
      targets: this.spike_taxi_png,
      x: this.spikeX,
      y: this.spikeY,
      scale: 1,
      duration: 1800,
      ease: Phaser.Math.Easing.Quadratic.Out,
      onComplete: this.startSpikeIdle,
      onCompleteScope: this
    });

    this.add.tween({
      targets: this.toots_taxi_png,
      x: this.tootsX,
      y: this.tootsY,
      scale: 1,
      duration: 1800,
      ease: Phaser.Math.Easing.Quadratic.Out,
      delay:200
    });

    this.add.tween({
      targets: this.spike_taxi_shadow_png,
      x: this.spikeShadowX,
      y: this.spikeShadowY,
      scale: 1,
      duration: 1800,
      ease: Phaser.Math.Easing.Quadratic.Out,
      delay:0
    });

    this.add.tween({
      targets: this.toots_taxi_shadow_png,
      x: this.tootsShadowX,
      y: this.tootsShadowY,
      scale: 1,
      duration: 1800,
      ease: Phaser.Math.Easing.Quadratic.Out,
      delay:200,
      onComplete: this.startTootsIdle,
      onCompleteScope: this
    });

    this.add.tween({
      targets: this.pigeon_1_png,
      x: this.p1X,
      y: this.p1Y,
      scale: 1,
      duration: 1200,
      delay: 0,
      ease: Phaser.Math.Easing.Cubic.Out,
      onComplete: this.pigeon1Idle,
      onCompleteScope: this
    });

    this.add.tween({
      targets: this.pigeon_2_png,
      x: this.p2X,
      y: this.p2Y,
      scale: 1,
      duration: 800,
      delay: 300,
      ease: Phaser.Math.Easing.Cubic.Out,
      onComplete: this.pigeon2Idle,
      onCompleteScope: this
    });

    this.add.tween({
      targets: this.pigeon_3_png,
      x: this.p3X,
      y: this.p3Y,
      scale: 1,
      duration: 1000,
      delay: 200,
      ease: Phaser.Math.Easing.Cubic.Out,
      onComplete: this.pigeon3Idle,
      onCompleteScope: this
    });

    this.add.tween({
      targets: this.pigeon_4_png,
      x: this.p4X,
      y: this.p4Y,
      scale: 1,
      duration: 600,
      delay: 500,
      ease: Phaser.Math.Easing.Cubic.Out,
      onComplete: this.pigeon4Idle,
      onCompleteScope: this
    });

    this.add.tween({
      targets: this.pigeon_5_png,
      x: this.p5X,
      y: this.p5Y,
      scale: 1,
      duration: 700,
      delay: 600,
      ease: Phaser.Math.Easing.Cubic.Out,
      onComplete: this.pigeon5Idle,
      onCompleteScope: this
    });

    this.add.tween({
      targets: this.feather_group_1_png,
      x: this.feather_group_1_png.x,
      y: this.feather_group_1_png.y,
      scale: 0.9,
      duration: 500,
      delay: 600,
      ease: Phaser.Math.Easing.Cubic.Out,
      onComplete: this.feather1Idle,
      onCompleteScope: this
    });

    this.add.tween({
      targets: this.feather_group_2_png,
      x: this.feather_group_2_png.x,
      y: this.feather_group_2_png.y,
      scale: 0.95,
      duration: 500,
      delay: 400,
      ease: Phaser.Math.Easing.Cubic.Out,
      onComplete: this.feather2Idle,
      onCompleteScope: this
    });

    this.add.tween({
      targets: this.feather_group_3_png,
      x: this.feather_group_3_png.x,
      y: this.feather_group_3_png.y,
      scale: 0.92,
      duration: 500,
      delay: 600,
      ease: Phaser.Math.Easing.Cubic.Out,
      onComplete: this.feather3Idle,
      onCompleteScope: this
    });

    this.water_jet_png.alpha=0;
    this.add.tween({
      targets: this.water_jet_png,
      x: this.waterX,
      y: this.waterY,
      scale: 1,
      alpha: 1,
      duration: 300,
      delay: 1200,
      ease: Phaser.Math.Easing.Cubic.In,
      onComplete: this.waterIdle,
      onCompleteScope: this
    });

    this.add.tween({
      targets: this.cab_png,
      scaleX: 1,
      scaleY: 1,
      x: this.cabX,
      y: this.cabY,
      duration: 1000,
      delay:0,
      ease: Phaser.Math.Easing.Cubic.Out,
      onComplete: this.cabIdle,
      onCompleteScope: this
    });

    this.time.addEvent({ delay: 1500, callback: this.startIdles, callbackScope: this });
  }

  protected cabIdle() {

    this.add.tween({
      targets: this.cab_png,
      scaleX: 1,
      scaleY: 0.999,
      x: this.cab_png.x + 0,
      y: this.cab_png.y - 0.3,
      duration: 500,
      ease: Phaser.Math.Easing.Linear,
      loop: -1,
      yoyo: true
    });
  }

  protected tomCardIdle() {

    this.add.tween({
      targets: this.tom_taxi_card_png,
      scaleX: this.card1InitScale + 0.01,
      scaleY: this.card1InitScale + 0.01,
      x: this.tom_taxi_card_png.x + 0,
      y: this.tom_taxi_card_png.y - 3,
      angle: this.card1InitAngle + 6,
      duration: 1500,
      ease: Phaser.Math.Easing.Linear,
      loop: -1,
      yoyo: true
    });
  }

  protected jerryCardIdle() {

    this.add.tween({
      targets: this.jerry_taxi_card_png,
      scaleX: this.card2InitScale + 0.01,
      scaleY: this.card2InitScale + 0.01,
      x: this.jerry_taxi_card_png.x + 0,
      y: this.jerry_taxi_card_png.y - 5,
      angle: this.card2InitAngle + -4,
      duration: 2000,
      ease: Phaser.Math.Easing.Linear,
      loop: -1,
      yoyo: true
    });
  }

  protected waterIdle() {

    this.add.tween({
      targets: this.water_jet_png,
      scaleX: 1.005,
      scaleY: 0.92,
      alpha: 0.9,
      x: this.water_jet_png.x + 0,
      y: this.water_jet_png.y + 5,
      duration: 300,
      ease: Phaser.Math.Easing.Linear,
      loop: -1,
      yoyo: true
    });
  }

  protected pigeon1Idle() {

    this.add.tween({
      targets: this.pigeon_1_png,
      scaleX: 1.003,
      scaleY: 0.94,
      x: this.pigeon_1_png.x + 0,
      y: this.pigeon_1_png.y + 15,
      duration: 2500,
      ease: Phaser.Math.Easing.Cubic.InOut,
      loop: -1,
      yoyo: true
    });
  }

  protected pigeon2Idle() {

    this.add.tween({
      targets: this.pigeon_2_png,
      scaleX: 1.003,
      scaleY: 0.94,
      x: this.pigeon_2_png.x + 0,
      y: this.pigeon_2_png.y + 8,
      duration: 1500,
      ease: Phaser.Math.Easing.Cubic.InOut,
      loop: -1,
      yoyo: true
    });
  }

  protected pigeon3Idle() {

    this.add.tween({
      targets: this.pigeon_3_png,
      scaleX: 1.003,
      scaleY: 0.94,
      x: this.pigeon_3_png.x + 0,
      y: this.pigeon_3_png.y + 4,
      duration: 1500,
      ease: Phaser.Math.Easing.Cubic.InOut,
      loop: -1,
      yoyo: true
    });
  }

  protected pigeon4Idle() {

    this.add.tween({
      targets: this.pigeon_4_png,
      scaleX: 1.003,
      scaleY: 0.94,
      x: this.pigeon_4_png.x + 0,
      y: this.pigeon_4_png.y + 3,
      duration: 1500,
      ease: Phaser.Math.Easing.Cubic.InOut,
      loop: -1,
      yoyo: true
    });
  }

  protected pigeon5Idle() {

    this.add.tween({
      targets: this.pigeon_5_png,
      scaleX: 1.003,
      scaleY: 0.94,
      x: this.pigeon_5_png.x + 0,
      y: this.pigeon_5_png.y + 8,
      duration: 1500,
      ease: Phaser.Math.Easing.Cubic.InOut,
      loop: -1,
      yoyo: true
    });
  }

  protected feather1Idle() {

    this.add.tween({
      targets: this.feather_group_1_png,
      scaleX: 1,
      scaleY: 1,
      x: this.feather_group_1_png.x + 0,
      y: this.feather_group_1_png.y + 3,
      duration: 2500,
      ease: Phaser.Math.Easing.Quadratic.InOut,
      loop: -1,
      yoyo: true
    });
  }
  protected feather2Idle() {

    this.add.tween({
      targets: this.feather_group_2_png,
      scaleX: 1,
      scaleY: 1,
      x: this.feather_group_2_png.x + 0,
      y: this.feather_group_2_png.y + 1,
      duration: 3500,
      ease: Phaser.Math.Easing.Quadratic.InOut,
      loop: -1,
      yoyo: true
    });
  }
  protected feather3Idle() {

    this.add.tween({
      targets: this.feather_group_3_png,
      scaleX: 1,
      scaleY: 1,
      x: this.feather_group_3_png.x + 0,
      y: this.feather_group_3_png.y + 3,
      duration: 3000,
      ease: Phaser.Math.Easing.Quadratic.InOut,
      loop: -1,
      yoyo: true
    });
  }

  protected tomIdle() {

    this.add.tween({
      targets: this.tom,
      scaleX: 1.005,
      scaleY: 1.02,
      x: this.tom.x + 0,
      y: this.tom.y + 3,
      duration: 900,
      ease: Phaser.Math.Easing.Quadratic.InOut,
      loop: -1,
      yoyo: true
    });
  }

  protected jerryIdle() {

    this.add.tween({
      targets: this.jerry,
      scaleX: 1.01,
      scaleY: 1.04,
      x: this.jerry.x + 0,
      y: this.jerry.y - 10,
      duration: 1000,
      ease: Phaser.Math.Easing.Quadratic.InOut,
      loop: -1,
      yoyo: true
    });
  }

  protected startSpikeIdle() {

    this.add.tween({
      targets: this.spike_taxi_png,
      scaleX: 1.003,
      scaleY: 1.003,
      y: this.spike_taxi_png.y - 0.7,
      duration: 200,
      ease: Phaser.Math.Easing.Cubic.InOut,
      loop: -1,
      yoyo: true
    });

    this.add.tween({
      targets: this.spike_taxi_shadow_png,
      scaleX: 0.99,
      scaleY: 0.99,
      duration: 200,
      ease: Phaser.Math.Easing.Cubic.InOut,
      loop: -1,
      yoyo: true
    });
  }

  protected startTootsIdle() {

    this.add.tween({
      targets: this.toots_taxi_png,
      scaleX: 1.001,
      scaleY: 1.002,
      y: this.toots_taxi_png.y - 0.4,
      duration: 200,
      ease: Phaser.Math.Easing.Cubic.InOut,
      loop: -1,
      yoyo: true
    });

    this.add.tween({
      targets: this.toots_taxi_shadow_png,
      scaleX: 0.992,
      scaleY: 0.992,
      duration: 200,
      ease: Phaser.Math.Easing.Cubic.InOut,
      loop: -1,
      yoyo: true
    });
  }

  protected startIdles() {
    this.add.tween({
      targets: this.subtitle,
      scaleX: 1.025,
      scaleY: 1.025,
      duration: 2000,
      ease: Phaser.Math.Easing.Cubic.InOut,
      loop: -1,
      yoyo: true
    });

    this.add.tween({
      targets: this.star_1_png,
      scale: { from: 0, to: 1 },
      alpha: { from: 1, to: 0 },
      duration: 1500,
      ease: Phaser.Math.Easing.Cubic.Out,
      loop: -1,
      yoyo: false,
      delay: 0,
      loopDelay: 0,
      repeatDelay:0
    });

    this.add.tween({
      targets: this.star_2_png,
      scale: { from: 0, to: 1 },
      alpha: { from: 1, to: 0 },
      duration: 1500,
      ease: Phaser.Math.Easing.Cubic.Out,
      loop: -1,
      yoyo: false,
      delay: 200,
      loopDelay: 0,
      repeatDelay:0
    });

    this.add.tween({
      targets: this.star_3_png,
      scale: { from: 0, to: 1 },
      alpha: { from: 1, to: 0 },
      duration: 1500,
      ease: Phaser.Math.Easing.Cubic.Out,
      loop: -1,
      yoyo: false,
      delay: 300,
      loopDelay: 0,
      repeatDelay:0
    });

    this.add.tween({
      targets: this.star_4_png,
      scale: { from: 0, to: 1 },
      alpha: { from: 1, to: 0 },
      duration: 1500,
      ease: Phaser.Math.Easing.Cubic.Out,
      loop: -1,
      yoyo: false,
      delay: 400,
      loopDelay: 0,
      repeatDelay:0
    });

    this.add.tween({
      targets: this.star_5_png,
      scale: { from: 0, to: 1 },
      alpha: { from: 1, to: 0 },
      duration: 1500,
      ease: Phaser.Math.Easing.Cubic.Out,
      loop: -1,
      yoyo: false,
      delay: 500,
      loopDelay: 0,
      repeatDelay:0
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
